import { $http } from './http';

import moment from 'moment';

class OzonService {
    loadAllProductsIds() {
        return $http.post('v2/product/list', {
            filter: {},
            page: 0,
            page_size: 999
        })
    }

    loadAllProductsInfo(productIds) {
        return $http.post('v2/product/info/list', {
            product_id: productIds
        })
    }

    async loadAllFboPostings(daysCount) {
        let resultPostings = [];
        let offset = 0;
        let postings = (await this.loadFboPostings(daysCount, offset)).data.result;

        while (postings.length) {
            resultPostings = resultPostings.concat(postings);
            offset += postings.length;
            postings = (await this.loadFboPostings(daysCount, offset)).data.result
        }

        return resultPostings;
    }

    loadFboPostings(daysCount, offset) {
        const since = moment().subtract((daysCount - 1), 'days').startOf('day');
        const to = moment().endOf('day');
        return $http.post('v2/posting/fbo/list', {
            dir: "asc",
            filter: {
                since,
                to
            },
            limit: 999,
            offset,
            with: {
                analytics_data: true,
                financial_data: false
            }
        })
    }

    //TODO: загружает только первые 1000 товаров
    loadPrices() {
        return $http.post('v2/product/info/prices', {
            page: 0,
            page_size: 1000
        })
    }
}

export default new OzonService();
